export enum ETariff {
    FREE = 'Free',
    STANDARD = 'Standard',
    PRO = 'Pro',
    ENTERPRISE = 'Enterprise',
}

export enum ETariffAbbr {
    FREE = 'mlp_free',
    STANDARD = 'mlp_standard',
    PRO = 'mlp_pro',
    ENTERPRISE = 'mlp_enterprise',
    STANDARD_2023 = 'mlp_website_minilanding_year_2023',
    PRO_2023 = 'mlp_website_pro_2023',
    ENTERPRISE_2023 = 'mlp_website_enterprise_2023',
}
